import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { uploadFile } from "./firebaseUpload";
import {
  addDoc,
  collection,
  limit,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  where,
} from "firebase/firestore";
import { db } from "../firebase";
import { notification } from "antd";
import { useNavigate } from "react-router-dom";
import { notificationDeepLink } from "./notifications";

export const emailFormat =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// Split a free-text "a@x.com, b@y.com" field into a clean address list.
export const splitEmails = (value) =>
  (value || "")
    .split(/[,;\s]+/)
    .map((s) => s.trim())
    .filter(Boolean);
// export const passwordFormat =
//     /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d][A-Za-z\d!@#$%^&*()_+]{7,24}$/   // just number/special chars
export const passwordFormat =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]).{8,10}$/; // all special chars

export const GreenNotify = (text) => {
  toast.success(text, {
    position: toast.POSITION.TOP_CENTER,
  });

  // toast.error("Error Notification !", {
  //   position: toast.POSITION.TOP_LEFT,
  // });

  // toast.warn("Warning Notification !", {
  //   position: toast.POSITION.BOTTOM_LEFT,
  // });

  // toast.info("Info Notification !", {
  //   position: toast.POSITION.BOTTOM_CENTER,
  // });

  // toast("Custom Style Notification with css class!", {
  //   position: toast.POSITION.BOTTOM_RIGHT,
  //   className: "foo-bar",
  // });
};

export const getFirebaseAuthErrorMessage = (code) => {
  switch (code) {
    case "auth/invalid-credential":
      return "Invalid email or password. Please try again.";
    case "auth/user-not-found":
      return "No account found with this email.";
    case "auth/wrong-password":
      return "Incorrect password.";
    case "auth/email-already-in-use":
      return "This email is already in use.";
    case "auth/too-many-requests":
      return "Too many attempts. Try again later.";
    case "auth/network-request-failed":
      return "Network error. Check your connection.";
    default:
      return "Something went wrong. Please try again.";
  }
};

export const RedNotify = (text) => {
  toast.error(text, {
    position: toast.POSITION.TOP_CENTER,
  });
};

export const useFirebaseUpload = () => {
  const [isUploading, setIsUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState(null);

  const uploadFiles = async (files) => {
    setIsUploading(true);
    setError(null);
    setProgress(0);

    try {
      if (!Array.isArray(files) || files.length === 0) {
        throw new Error("No files received for upload");
      }

      const uploadedFiles = [];
      const totalFiles = files.length;

      for (let i = 0; i < totalFiles; i++) {
        const file = files[i];
        if (!file) {
          throw new Error(`File at index ${i} is undefined`);
        }

        // Firebase Storage upload. Property images -> "property-images/".
        const publicUrl = await uploadFile(file, "property-images");
        if (!publicUrl) {
          throw new Error(`Upload failed for ${file?.name}`);
        }

        uploadedFiles.push({ id: publicUrl, image: publicUrl });
        setProgress(Math.round(((i + 1) / totalFiles) * 100));
      }

      return uploadedFiles;
    } catch (err) {
      const normalizedMessage = err?.message || "Image upload failed";
      setError(normalizedMessage);
      throw new Error(normalizedMessage);
    } finally {
      setIsUploading(false);
    }
  };

  return {
    uploadFiles,
    isUploading,
    progress,
    error,
    reset: () => {
      setProgress(0);
      setError(null);
    },
  };
};

export const handleEmailCheck = (text, errors, setErrors, apiCall = false) => {
  const emailValue =
    text == ""
      ? "Email is Required"
      : emailFormat.test(text) || text === ""
      ? null
      : "Provide a valid Email address";
  setErrors({ ...errors, fieldName: "Email", email: emailValue });
  if (apiCall && emailValue != null) {
    RedNotify(emailValue);
  }
  return emailValue === null;
};

export const handlePasswordCheck = (
  text,
  errors,
  setErrors,
  apiCall = false,
  confirmPassword = ""
) => {
  const passwordLengthError =
    text == ""
      ? "Password Field is Required"
      : !passwordFormat.test(text)
      ? "Password must contain at least one lowercase letter, one uppercase letter, one digit, one special character, and be between 8 to 10 characters long"
      : null;

  const confirmPasswordError =
    confirmPassword !== text
      ? confirmPassword == ""
        ? null
        : "Passwords do not match with confirm password"
      : null;

  console.log("confirmPasswordError", confirmPasswordError);
  const passwordValue = passwordLengthError || confirmPasswordError;
  // const passwordValue = passwordLengthError;
  setErrors({ ...errors, fieldName: "Password", password: passwordValue });
  if (apiCall && passwordValue != null) {
    RedNotify(passwordValue);
  }
  return passwordValue === null;
};

export const sendPushNotification = async (
  expoPushToken,
  title,
  body,
  user,
  details
) => {
  const message = {
    to: expoPushToken,
    sound: "default",
    title: String(title),
    body: String(body),
  };

  console.log("push message", message);

  try {
    await fetch("https://exp.host/--/api/v2/push/send", {
      method: "POST",
      mode: "no-cors", // required for browser
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(message),
    });

    // You can only assume it was sent (no way to check from frontend)
    await addDoc(collection(db, "notifications"), {
      to: user?.uuid || "",
      token: expoPushToken,
      title: String(title),
      details,
      body: String(body),
      sentAt: serverTimestamp(),
      status: "sent", // optimistic
      isRead: false,
    });

    console.log("✅ Notification request sent (frontend, no response check)");
  } catch (error) {
    console.log("Push notification error:", error);

    await addDoc(collection(db, "notifications"), {
      to: user?.uuid,
      token: expoPushToken,
      title: String(title),
      details,
      body: String(body),
      sentAt: serverTimestamp(),
      status: "failed",
      isRead: false,
    });

    RedNotify("Failed to send notification. Please try again.");
  }
};

export const useNotificationListener = (userId) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (!userId) return;

    // Bounded to the most recent few — this listener only pops a toast on newly
    // ADDED docs, so it never needs the full inbox history. Reuses the existing
    // (to, sentAt) composite index.
    const q = query(
      collection(db, "notifications"),
      where("to", "==", userId),
      orderBy("sentAt", "desc"),
      limit(15),
    );

    // Firestore delivers EVERY existing doc as `added` on the first snapshot of
    // each subscription. Track first-snapshot per-subscription (local, not a
    // persistent ref) so a re-subscribe — e.g. userId changing once when redux
    // rehydrates then a fresh fetch overwrites it — doesn't replay the whole
    // window as a wall of cards.
    let isInitialSnapshot = true;
    const unsubscribe = onSnapshot(q, (snapshot) => {
      if (isInitialSnapshot) {
        isInitialSnapshot = false;
        return;
      }

      snapshot.docChanges().forEach((change) => {
        if (change.type === "added") {
          const data = change.doc.data();
          notification.open({
            key: change.doc.id,
            message: data.title || "New Notification",
            description: data.body || "You have a new update.",
            placement: "topRight",
            onClick: () => {
              navigate(notificationDeepLink(data.details) || "/notifications");
            },
          });
        }
      });
    }, (error) => {
      // e.g. transient permission-denied while auth is restoring or after
      // sign-out; log instead of throwing an unhandled listener error.
      console.warn("notification listener stopped:", error?.message);
    });

    return () => unsubscribe();
  }, [userId]); // ✅ dependency array should include userId
};
